module.exports = __webpack_public_path__ + "static/media/tawuniyaDrivePrimary.3796c012.svg";